import React from "react";
import * as Icons from "lucide-react";
import { cn } from "@/lib/utils";
import { money } from "@/lib/format";

const TONES = {
  primary: "bg-primary-soft text-primary",
  success: "bg-success-soft text-success",
  warning: "bg-warning-soft text-warning",
  danger: "bg-destructive-soft text-destructive",
  info: "bg-info-soft text-info",
  neutral: "bg-muted text-muted-foreground",
};

export const StatCard = ({ label, value, icon = "Circle", tone = "neutral", currency, hint, onClick, index = 0, testId }) => {
  const Icon = Icons[icon] || Icons.Circle;
  const slug = testId || `stat-${String(label).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={slug}
      style={{ animationDelay: `${Math.min(index, 10) * 35}ms` }}
      className={cn(
        "animate-fade-up group flex w-full flex-col items-start gap-3 rounded-xl border border-border bg-card p-4 text-left shadow-xs",
        "transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-md",
        !onClick && "cursor-default"
      )}
    >
      <div className="flex w-full items-start justify-between gap-2">
        <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</span>
        <span className={cn("grid h-8 w-8 place-items-center rounded-lg transition-transform duration-200 group-hover:scale-110", TONES[tone])}>
          <Icon className="h-4 w-4" />
        </span>
      </div>
      <div className="num text-2xl font-bold leading-none text-foreground" data-testid={`${slug}-value`}>
        {currency ? money(value, true)
          : typeof value === "number" ? value.toLocaleString("en-IN") : (value ?? 0)}
      </div>
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </button>
  );
};
